// COPY parcial de apps/desktop/src/features/knowledge/api.ts; dedup em F13.
import type { components } from '@copilot/shared-types';
import { httpClient } from '../../shared/http/client';
import type { KnowledgeDocType, KnowledgeStatus } from './status';

export type KnowledgeDocument = components['schemas']['KnowledgeDocumentPublic'];

export interface KnowledgeListParams {
  status?: KnowledgeStatus | undefined;
  doc_type?: KnowledgeDocType | undefined;
  search?: string | undefined;
  cursor?: string | undefined;
  limit?: number | undefined;
}

export interface PageInfo {
  limit: number;
  next_cursor?: string | null;
}

export interface PageEnvelope<T> {
  items: T[];
  pagination: PageInfo;
}

export async function listKnowledge(
  params: KnowledgeListParams,
): Promise<PageEnvelope<KnowledgeDocument>> {
  const res = await httpClient.get<PageEnvelope<KnowledgeDocument>>('/api/v1/knowledge', {
    params,
  });
  return res.data;
}

export interface UploadKnowledgeInput {
  file: File | null;
  filename: string;
  doc_type: KnowledgeDocType;
}

export async function uploadKnowledge(input: UploadKnowledgeInput): Promise<KnowledgeDocument> {
  const form = new FormData();
  form.append('doc_type', input.doc_type);
  form.append('filename', input.filename);
  if (input.file !== null) {
    form.append('file', input.file, input.filename);
  }
  const res = await httpClient.post<KnowledgeDocument>('/api/v1/knowledge', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
}

export async function deleteKnowledge(docId: string): Promise<void> {
  await httpClient.delete(`/api/v1/knowledge/${docId}`);
}

export async function reindexKnowledge(docId: string): Promise<KnowledgeDocument> {
  const res = await httpClient.post<KnowledgeDocument>(`/api/v1/knowledge/${docId}/reindex`);
  return res.data;
}
